/**
 * "Open Work on this" from anywhere (Lumen-BE 0092): an alarm's drawer, the NOC, a cabinet, My
 * work. A screen asks here; the shell (`App.tsx`) switches to Work and hands the request over once.
 * A store rather than a callback threaded through every screen that shows an alarm.
 */
import { create } from 'zustand';
import type { CreateWorkInput } from '@/lib/api/work';

export type WorkRequest =
  | { kind: 'draft'; draft: Partial<CreateWorkInput> }
  | { kind: 'open'; id: string }
  /** Work, on one of its queues — the NOC's overdue maintenance. */
  | { kind: 'queue'; queue: 'open' | 'mine' | 'overdue' | 'done' | 'all' }
  /** Work's maintenance schedules — a cabinet's Life Cycle *Schedule*. */
  | { kind: 'schedules' };

interface WorkNav {
  request: WorkRequest | null;
  /** Open the new-work-order form, prefilled. */
  draft: (draft: Partial<CreateWorkInput>) => void;
  /** Open one work order. */
  open: (id: string) => void;
  /** Open Work on a queue. */
  queue: (queue: Extract<WorkRequest, { kind: 'queue' }>['queue']) => void;
  /** Open Work on its maintenance schedules. */
  schedules: () => void;
  clear: () => void;
}

export const useWorkNav = create<WorkNav>((set) => ({
  request: null,
  draft: (draft) => set({ request: { kind: 'draft', draft } }),
  open: (id) => set({ request: { kind: 'open', id } }),
  queue: (queue) => set({ request: { kind: 'queue', queue } }),
  schedules: () => set({ request: { kind: 'schedules' } }),
  clear: () => set({ request: null }),
}));
